import { PropsWithChildren, useState } from 'react'

import clsx from 'clsx'

import { flip, shift, useFloating } from '@floating-ui/react'
import { Transition } from '@headlessui/react'

interface TooltipProps {
  contentComponent: string | JSX.Element
  className?: string
}

const Tooltip = ({
  contentComponent,
  className,
  children
}: PropsWithChildren<TooltipProps>) => {
  const [isOpen, setIsOpen] = useState(false)

  const onOpen = () => setIsOpen(true)
  const onClose = () => setIsOpen(false)

  const { refs, floatingStyles } = useFloating({
    placement: 'bottom-start',
    middleware: [flip(), shift({ crossAxis: true })]
  })

  return (
    <div
      className="relative inline-flex h-fit w-fit"
      onClick={(event) => event.preventDefault()}
      onMouseEnter={onOpen}
      onMouseLeave={onClose}
    >
      <div
        className="inline-flex cursor-pointer items-center align-middle"
        ref={refs.setReference}
      >
        {children}
      </div>
      <Transition
        className="absolute bottom-full top-auto z-20"
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        show={isOpen}
      >
        <div
          className={clsx(
            'm-2 w-max rounded-xl bg-white px-3 py-2 text-sm shadow-md',
            className
          )}
          ref={refs.setFloating}
          style={floatingStyles}
        >
          {contentComponent}
        </div>
      </Transition>
    </div>
  )
}
export default Tooltip
